import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { ISociosChart } from "../../../interfaces/SociosChart";
import { getSociosChartData, getSociosPorTipoPais } from "../../../api/sociosChart";
import { ChartContainerLoader } from "../../../components/Generic/Charts";
import PieChart from "../../../components/Charts/PieChart";
import { IContrapartesWs } from "../../../interfaces/Workspace";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons";
import Iniciativas from "./Iniciativas";

const ListaContrapartes: React.FC<{
    contrapartesFiltradas?: IContrapartesWs[]
    setContraparteSeleccionada: (contraparte: number) => void
}> = ({ contrapartesFiltradas, setContraparteSeleccionada }) => {
    const { t } = useTranslation("translation", { keyPrefix: "contrapartes" });
    if (!contrapartesFiltradas) {
        return <ChartContainerLoader colSize="12" />;
    }


    return (
        <div className="card">
            <div className="card-body listado-contrapartes-lateral">
                <small>{t("encontraron", {quantity:contrapartesFiltradas.length})}</small>
                <ul className="mt-2 list-unstyled overflow-y-auto overflow-x-hidden">
                    {contrapartesFiltradas?.map((contraparte, index) => {
                        return (
                            <li className="pb-4 pt-4 border-bottom" key={index}>
                                <div className="row align-items-center">
                                    <div className="col-12">
                                        <span className="text-iica-2 text-justify">{contraparte.descripcion}</span>
                                    </div>
                                </div>
                                <div className="col-4 mt-2">
                                    <button className="btn btn-success" onClick={() => setContraparteSeleccionada(contraparte.id_ContraFinanciera)}>
                                        <FontAwesomeIcon
                                            icon={faList}
                                            className="me-3"
                                        />
                                        {t("iniciativas")}
                                    </button>
                                </div>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </div>
    )
}

const Contrapartes: React.FC<{ code?: string }> = ({ code }) => {

    const { t, i18n } = useTranslation("translation", { keyPrefix: "contrapartes" });

    const [contrapartesData, setContrapartesData] = useState<ISociosChart[]>();
    const [contrapartesFiltrads, setContrapartesFiltradas] = useState<IContrapartesWs[]>();
    const [tipoContraparteFiltrada, setTipoContraparteFiltrada] = useState<number>();
    const [contraparteSeleccionada, setContraparteSeleccionada] = useState<number>();

    const iniciativasContainer = useRef<HTMLDivElement>(null);

    useEffect(() => {
        getSociosChartData(code, i18n.language).then((res) => {
            setContrapartesData(res);
            return;
        });
        return () => {
            // cleanup
            setContrapartesData(undefined)
            setContrapartesFiltradas(undefined)
            setTipoContraparteFiltrada(undefined)
        }
    }, [code, i18n.language]);

    useEffect(() => {
        getSociosPorTipoPais(code, tipoContraparteFiltrada)
            .then((res) => {
                setContrapartesFiltradas(res);
                setContraparteSeleccionada(undefined)
            })
        return () => {
            // cleanup
            setContrapartesFiltradas(undefined)
            setContraparteSeleccionada(undefined)
        }
    }, [code, tipoContraparteFiltrada])

    useEffect(() => {
        iniciativasContainer.current?.scrollIntoView({behavior:"smooth"})
    }, [contraparteSeleccionada])

    if (!contrapartesData) {
        return <ChartContainerLoader colSize={"12"} />;
    }

    return (
        <div className="card" id="contrapartes" style={{ minHeight: "31rem" }}>
            <div className="card-body">
                <div className="row">
                    <div className="col-lg-6">
                        <PieChart chartName={t("intro_chart")} data={contrapartesData!} setContraparteSeleccionada={setContraparteSeleccionada} setTipoContraparteFiltrada={setTipoContraparteFiltrada} />
                    </div>
                    <div className="col-lg-6">
                        <ListaContrapartes contrapartesFiltradas={contrapartesFiltrads} setContraparteSeleccionada={setContraparteSeleccionada} />
                    </div>
                </div>
                {
                    contraparteSeleccionada ?
                        <div className="row" ref={iniciativasContainer}>
                            <div className="col-lg-12">
                                <Iniciativas code={code} contraparte={contraparteSeleccionada} />
                            </div>
                        </div> : null
                }
            </div>
        </div>
    )
}

export default Contrapartes;